export class Setting {
  key: string;
  label: string;
  description: string;
  type: string;
  defaultValue: any;
  currentValue: any;

  constructor(payload?: any) {
    if (payload) {
      this.key = payload.key;
      this.label = payload.label;
      this.description = payload.description;
      this.type = payload.type;
      this.defaultValue = payload.defaultValue;
      this.currentValue = payload.currentValue;
    }
  }
}
